import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";

export class CreditHoldDetailFilters implements IFilterBar {

    public paginationInfo: PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl: string = ApiEndpoints.ORDERING_CREDIT_HOLD_DETAILS;
    public filters: FilterGroup[] = [];
    public appliedFilters: AppliedFilterBarOpt[] = [];
    public requiredFilters: AppliedFilterBarOpt[] = [];
    public columns: ListColumn[];
    public selectedSort: SelectedSort;

    constructor(dealerId: string, creationDate?: string, cutoffDate?: string, matchDayOfWeek?: string, orderId?: string) {

        // Set our table columns
        this.columns = [
            new ListColumn('', '', false),
            new ListColumn('Order ID', '', false),
            new ListColumn('Description', '', false),
			new ListColumn('PO', '', false),
			new ListColumn('Job Name', '', false),
            new ListColumn('Cutoff', '', false),
            new ListColumn('Created On', '', false),
            new ListColumn('Total', '', false)
        ];

        // Dealer ID is required
        // Everything else is optional based on the search criteria

        this.appliedFilters.push({
            uuid: 'unused',
            label: 'unused',
            qsName: 'dealerId',
            qsValue: dealerId
        });

        if (creationDate) {
            this.appliedFilters.push({
                uuid: 'unused',
                label: 'unused',
                qsName: 'maxCreationDate',
                qsValue: creationDate
            });
        }

        if (cutoffDate) {
            this.appliedFilters.push({
                uuid: 'unused',
                label: 'unused',
                qsName: 'maxCutoff',
                qsValue: cutoffDate
            });
        }

        if (matchDayOfWeek) {
            this.appliedFilters.push({
                uuid: 'unused',
                label: 'unused',
                qsName: 'matchDayOfWeek',
                qsValue: matchDayOfWeek
            });
        }

        if (orderId) {
            this.appliedFilters.push({
                uuid: 'unused',
                label: 'unused',
                qsName: 'orderId',
                qsValue: orderId
            });
        }
    }
}
